import React from 'react';
import { Phone, MapPin, Mail } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-slate-900 border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand */}
          <div>
            <h3 className="text-2xl font-bold bg-gradient-to-r from-cyan-600 to-blue-700 bg-clip-text text-transparent mb-4">
              SUB-ZERO
            </h3>
            <p className="text-slate-600 mb-4">
              Revolutionary refrigerated air dryer technology achieving sub-zero pressure dew points with unmatched energy efficiency.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-slate-900 font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-slate-600 hover:text-cyan-600 transition-colors duration-300"
                >
                  About Us
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('technology')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-slate-600 hover:text-cyan-600 transition-colors duration-300"
                >
                  Novel Technology
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('specs')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-slate-600 hover:text-cyan-600 transition-colors duration-300"
                >
                  Technical Specifications
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('manufacturing')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-slate-600 hover:text-cyan-600 transition-colors duration-300"
                >
                  Contract Manufacturing
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-slate-600 hover:text-cyan-600 transition-colors duration-300"
                >
                  Contact Us
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-slate-900 font-semibold mb-4">Contact Information</h4>
            <ul className="space-y-3">
              <li className="flex items-start">
                <Phone className="text-cyan-600 mr-3 flex-shrink-0 mt-1" size={18} />
                <div className="flex flex-col">
                  <a
                    href="tel:+919894038894"
                    className="text-slate-600 hover:text-cyan-600 transition-colors duration-300"
                  >
                    +91 98940 38894
                  </a>
                  <a
                    href="tel:+918870038894"
                    className="text-slate-600 hover:text-cyan-600 transition-colors duration-300"
                  >
                    +91 88700 38894
                  </a>
                </div>
              </li>
              <li className="flex items-start">
                <Mail className="text-cyan-600 mr-3 flex-shrink-0 mt-1" size={18} />
                <a
                  href="mailto:arun@atseng.in"
                  className="text-slate-600 hover:text-cyan-600 transition-colors duration-300"
                >
                  arun@atseng.in
                </a>
              </li>
              <li className="flex items-start">
                <MapPin className="text-cyan-600 mr-3 flex-shrink-0 mt-1" size={18} />
                <span className="text-slate-600">
                  Pilot Factory (Sub-Zero Dryers),<br />
                  SF246/3D Sriram Gardens,<br />
                  Maharani Ave 1st Ph, Vadavalli,<br />
                  Coimbatore 641041,<br />
                  TamilNadu, India
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-200 mt-8 pt-8 text-center">
          <p className="text-slate-500 text-sm">
            © {new Date().getFullYear()} Sub-Zero Technology. All rights reserved. Patent Pending.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;